import { QueryFn } from "angularfire2/firestore/interfaces";
import * as firebase from 'firebase/app';
import { BatchElement, FirestoreService } from "../app/services/firestore/firestore.service";
import { Utils } from "../app/util";
import { ProductionOrderId } from "../app/services/production-order.service";
import { Globals } from "../app/globals";

type WhereOpt = '<' | '<=' | '==' | '>=' | '>';
type ColRef = firebase.firestore.CollectionReference;
type Query = firebase.firestore.Query;
type Where<Doc, K extends keyof Doc> = {field: K, opt: WhereOpt, value: Doc[K]}

type NewValue<Doc, K extends keyof Doc> = (doc: Doc) => Doc[K];

/**
 * Class DevQuery
 * ¡¡¡ FOR DEVELOPERS ONLY !!! Do not use this class for user processes.
 * Replicates firestore query functions with strict type checking.
 */
export class DevQuery{
    static where<Doc, K extends keyof Doc>(query: ColRef | Query, {field, opt, value}: Where<Doc, K>): Query{
        return query.where(field, opt, value);
    }
}

/**
 * Class DevDatabase
 * ¡¡¡ FOR DEVELOPERS ONLY !!! Do not use this class for user processes.
 * Toolset for managing database operations, like adding a new field to a collection, or damage repair.
 */
export class DevDatabase {
    
    /**
     * constructor
     */
    constructor(
        private firestoreService: FirestoreService,
    ){}

    /* async setField<Doc extends {id: string}, K extends keyof Doc>(colPath: string, fieldKey: K, getValue: NewValue<Doc, K>, wheres: Where<Doc, keyof Doc>[] = []): Promise<void>{
        if(!confirm(`run DevDatabase.setField(
            ${colPath},
            ${fieldKey},
            ${getValue.toString()},
            ${wheres.map(where => JSON.stringify(where)).join(', ')},
        )`)) return;

        let docs: Doc[] = await this.firestoreService.colWithIds<Doc>(colPath, ref => {
            let query: firebase.firestore.Query = ref;//.where('','==','');
            for(let where of wheres) query = DevQuery.where(query, where);
            return query;
        });
        let batchs: BatchElement<'update'>[] = [];
        for(let doc of docs){
            let batch: typeof batchs[0] = {
                type: 'update',
                docPath: `${colPath}/${doc.id}`,
                data: { [fieldKey as string]: getValue(doc) },
            };
            batchs.push(batch);
        }
        let success: boolean = await this.firestoreService.batch(batchs);
        alert(`DevDatabase.setField: ${success ? 'Success' : 'Error'}!`);
    } */

    async exportColToJson<Doc extends {id: string}>(colPath: string, { subColPath = '', wheres = [] }: { subColPath?: string, wheres?: Where<Doc, keyof Doc>[] } = {}){
        console.log(`Exporting '${colPath}.${subColPath || '<no sub col>'}' to json.`);
        let docs: Doc[] = await this.firestoreService.colWithIds<Doc>(colPath, ref => {
            let query: firebase.firestore.Query = ref;
            for(let where of wheres) query = DevQuery.where(query, where);
            return query;
        });
        console.log(`Received ${docs.length} docs.`);
        if(subColPath){
            for(let doc of docs){
                let subDocs = await this.firestoreService.colWithIds(`${colPath}/${doc.id}/${subColPath}`);
                console.log(`Received subdocs.`);
                doc[`subCol_${subColPath}`] = subDocs;
            }
        }
        console.log(docs);
        Utils.downloadAsJsonFile(docs, colPath);
    }

    async archiveOdpsToDifferentCollection(){
        let applyBeforeDate = '2021-12-31';
        let col = Globals.PRODUCTION_ORDER_COLLECTION;
        let newCol = `before_${applyBeforeDate}_${col}`;
        let inlcudeMove = confirm(`Include move?`);
        let includeSetUnactive = confirm(`Include set unactive?`);
        let includeDelete = !includeSetUnactive && prompt(`Type upper case 'delete' to include delete.`) === 'DELETE';
        if(!confirm(`Archive from ${col} to ${newCol} before ${applyBeforeDate}?\nInclude move: ${inlcudeMove}\nInclude setUnactive: ${includeSetUnactive}\nInclude delete: ${includeDelete}`)) return;
        let odps = await this.firestoreService.colWithIds<ProductionOrderId>(col, ref => {
            let query: firebase.firestore.Query = ref;
            query = DevQuery.where<ProductionOrderId, 'date'>(query, { field: 'date', opt: '<=', value: applyBeforeDate });
            return query;
        });
        console.log(`Obtained '${odps.length}' odps till '${applyBeforeDate}'.`);
        let copyOfOdps = [ ...odps ];
        while(copyOfOdps.length){
            let limitedOdps = copyOfOdps.splice(0, inlcudeMove && (includeSetUnactive || includeDelete) ? 200 : 400);
            let batch = this.firestoreService.afs.firestore.batch();
            for(let odp of limitedOdps){
                if(inlcudeMove) batch.set(this.firestoreService.afs.firestore.doc(`${newCol}/${odp.id}`), { ...odp });
                if(includeSetUnactive) batch.update(this.firestoreService.afs.firestore.doc(`${col}/${odp.id}`), { active: `before_${applyBeforeDate}_${odp.active}` });
                if(includeDelete) batch.delete(this.firestoreService.afs.firestore.doc(`${col}/${odp.id}`));
            }
            await batch.commit();
            console.log(`Committed batch of ${limitedOdps.length} elements.`);
        }
    }
}
